"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentDomain = currentDomain;
exports.getCustomDomainAssets = getCustomDomainAssets;
exports.updateCustomDomainAssets = updateCustomDomainAssets;
exports.uploadCustomDomainIconOrLogo = uploadCustomDomainIconOrLogo;
exports.purchaseDomain = purchaseDomain;
exports.verifyDomain = verifyDomain;
exports.dnsSetupInfo = dnsSetupInfo;
exports.searchDomains = searchDomains;
exports.connectDomain = connectDomain;
exports.disconnectDomain = disconnectDomain;
exports.getSubaccounts = getSubaccounts;
exports.getInvitationLink = getInvitationLink;
exports.createSubaccount = createSubaccount;
exports.deleteSubaccount = deleteSubaccount;
exports.subaccountSignup = subaccountSignup;
exports.getResetPasswordLink = getResetPasswordLink;
exports.ticketLogin = ticketLogin;
exports.addOnmailAlias = addOnmailAlias;
exports.getDnsRecords = getDnsRecords;
exports.updateDnsRecords = updateDnsRecords;
exports.endpoints = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _moment = _interopRequireDefault(require("moment"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _functools = require("@edison/functools");

var _requests = require("@edison/requests");

var _utils = require("./utils");

var _constants = require("../utils/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var endpoints = {
  domain: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain");
    }
  },
  getAssets: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/custom_domain/assets");
    }
  },
  updateAssets: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain/assets");
    }
  },
  uploadIconOrLogo: {
    method: 'PUT',
    url: function url(type) {
      return "/".concat(_constants.API_V1, "/custom_domain/").concat(type);
    }
  },
  purchase: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain/purchase");
    }
  },
  verify: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain/verify");
    }
  },
  dnsSetupInfo: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain/verification/settings");
    }
  },
  search: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/custom_domain/search");
    }
  },
  connectDomain: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain");
    }
  },
  disconnectDomain: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain");
    }
  },
  // Sub accounts
  getSubaccounts: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/subaccount/list");
    }
  },
  getInvitationLink: {
    method: 'GET',
    url: function url(subaccountId) {
      return "/".concat(_constants.API_V1, "/subaccount/").concat(subaccountId, "/invitation_link");
    }
  },
  createSubaccount: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/subaccount");
    }
  },
  deleteSubaccount: {
    method: 'DELETE',
    url: function url(subaccountId) {
      return "/".concat(_constants.API_V1, "/subaccount/").concat(subaccountId);
    }
  },
  subaccountSignUp: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/subaccount/signup");
    }
  },
  addAlias: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/subaccount/onmail_alias");
    }
  },
  getResetPasswordLink: {
    method: 'GET',
    url: function url(subaccountId) {
      return "/".concat(_constants.API_V1, "/subaccount/").concat(subaccountId, "/forgot");
    }
  },
  ticketLogin: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/domain/login");
    }
  },
  getDnsRecords: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain/records");
    }
  },
  updateDnsRecords: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/custom_domain/records");
    }
  }
};
exports.endpoints = endpoints;

function currentDomain(_x) {
  return _currentDomain.apply(this, arguments);
}

function _currentDomain() {
  _currentDomain = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, optionals, _endpoints$domain, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$domain = endpoints.domain, method = _endpoints$domain.method, url = _endpoints$domain.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context.sent;

            if (!(res.status !== 200)) {
              _context.next = 8;
              break;
            }

            throw new _requests.RequestError(res.message, res.status, res.status);

          case 8:
            return _context.abrupt("return", res);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _currentDomain.apply(this, arguments);
}

function getCustomDomainAssets(_x2) {
  return _getCustomDomainAssets.apply(this, arguments);
}

function _getCustomDomainAssets() {
  _getCustomDomainAssets = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(domain) {
    var optionals, _endpoints$getAssets, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            optionals = (0, _requests.withParams)({
              domain: domain
            })(_utils.defaultOptionals);
            _endpoints$getAssets = endpoints.getAssets, method = _endpoints$getAssets.method, url = _endpoints$getAssets.url;
            _context2.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getCustomDomainAssets.apply(this, arguments);
}

function updateCustomDomainAssets(_x3, _x4, _x5) {
  return _updateCustomDomainAssets.apply(this, arguments);
}
/**
 * Upload icon/logo to custom domain assets
 *
 * @public
 * @param {Blob} icon|logo - The assets file to upload
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<APIResponse<string>>}
 */


function _updateCustomDomainAssets() {
  _updateCustomDomainAssets = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(companyName, color, _ref2) {
    var auth, optionals, _endpoints$updateAsse, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            auth = _ref2.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              companyName: companyName,
              color: color
            }))(_utils.defaultOptionals);
            _endpoints$updateAsse = endpoints.updateAssets, method = _endpoints$updateAsse.method, url = _endpoints$updateAsse.url;
            _context3.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _updateCustomDomainAssets.apply(this, arguments);
}

function uploadCustomDomainIconOrLogo(_x6, _x7, _x8, _x9) {
  return _uploadCustomDomainIconOrLogo.apply(this, arguments);
}

function _uploadCustomDomainIconOrLogo() {
  _uploadCustomDomainIconOrLogo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(domain, type, assets, _ref3) {
    var auth, form, getUrl, options, _endpoints$uploadIcon, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref3.auth;
            form = new FormData();

            getUrl = function getUrl(type) {
              return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/custom_domain/").concat(type);
            };

            form.append(type, assets);
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(form))({});
            _endpoints$uploadIcon = endpoints.uploadIconOrLogo, method = _endpoints$uploadIcon.method, url = _endpoints$uploadIcon.url;
            res = fetch(url(type), _objectSpread({
              method: method
            }, options)).then(function () {
              return "".concat(getUrl(type), "?domain=").concat(domain, "&v=").concat((0, _moment["default"])().unix());
            });
            return _context4.abrupt("return", res);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _uploadCustomDomainIconOrLogo.apply(this, arguments);
}

function purchaseDomain(_x10, _x11, _x12, _x13) {
  return _purchaseDomain.apply(this, arguments);
}

function _purchaseDomain() {
  _purchaseDomain = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(domain, domainPrice, currency, _ref4) {
    var auth, subscriptionId, optionals, _endpoints$purchase, method, url, res, success, _res$result, subscription, _domain;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            auth = _ref4.auth, subscriptionId = _ref4.subscriptionId;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              domain: domain,
              domainPrice: domainPrice,
              subscriptionId: subscriptionId
            }))(_utils.defaultOptionals);
            _endpoints$purchase = endpoints.purchase, method = _endpoints$purchase.method, url = _endpoints$purchase.url;
            _context5.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context5.sent;
            success = res.status === 200;

            if (!(0, _isNil["default"])(res.result)) {
              _context5.next = 9;
              break;
            }

            throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);

          case 9:
            _res$result = res.result, subscription = _res$result.subscription, _domain = _res$result.domain;
            return _context5.abrupt("return", {
              success: success,
              subscription: subscription,
              domain: _domain
            });

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _purchaseDomain.apply(this, arguments);
}

function verifyDomain(_x14, _x15) {
  return _verifyDomain.apply(this, arguments);
}

function _verifyDomain() {
  _verifyDomain = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(domain, _ref5) {
    var auth, optionals, _endpoints$verify, method, url, res;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            auth = _ref5.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              domain: domain
            }))(_utils.defaultOptionals);
            _endpoints$verify = endpoints.verify, method = _endpoints$verify.method, url = _endpoints$verify.url;
            _context6.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", res);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _verifyDomain.apply(this, arguments);
}

function dnsSetupInfo(_x16) {
  return _dnsSetupInfo.apply(this, arguments);
}

function _dnsSetupInfo() {
  _dnsSetupInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref6) {
    var auth, optionals, _endpoints$dnsSetupIn, method, url, res;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            auth = _ref6.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$dnsSetupIn = endpoints.dnsSetupInfo, method = _endpoints$dnsSetupIn.method, url = _endpoints$dnsSetupIn.url;
            _context7.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context7.sent;
            return _context7.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: res.result.map(function (record) {
                return _objectSpread(_objectSpread({}, record), {}, {
                  cached: record.cached ? record.cached.filter(Boolean) : []
                });
              })
            }));

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _dnsSetupInfo.apply(this, arguments);
}

function searchDomains(_x17, _x18) {
  return _searchDomains.apply(this, arguments);
}

function _searchDomains() {
  _searchDomains = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(query, _ref7) {
    var username, _ref7$limit, limit, optionals, _endpoints$search, method, url, res, result;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            username = _ref7.username, _ref7$limit = _ref7.limit, limit = _ref7$limit === void 0 ? 5 : _ref7$limit;
            optionals = (0, _functools.compose)((0, _requests.withBody)({
              query: query,
              limit: limit,
              username: username
            }))(_utils.defaultOptionals);
            _endpoints$search = endpoints.search, method = _endpoints$search.method, url = _endpoints$search.url;
            _context8.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context8.sent;
            result = {
              domains: (0, _get["default"])(res.result, 'domains', []) || []
            };
            return _context8.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: result
            }));

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _searchDomains.apply(this, arguments);
}

function connectDomain(_x19, _x20) {
  return _connectDomain.apply(this, arguments);
}

function _connectDomain() {
  _connectDomain = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(domain, _ref8) {
    var auth, optionals, _endpoints$connectDom, method, url, res;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            auth = _ref8.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              domain: domain,
              userOwned: true
            }))(_utils.defaultOptionals);
            _endpoints$connectDom = endpoints.connectDomain, method = _endpoints$connectDom.method, url = _endpoints$connectDom.url;
            _context9.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context9.sent;

            if (!(res.status !== 200)) {
              _context9.next = 8;
              break;
            }

            throw new _requests.RequestError(res.message, res.status, res.status);

          case 8:
            return _context9.abrupt("return", res);

          case 9:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _connectDomain.apply(this, arguments);
}

function disconnectDomain(_x21) {
  return _disconnectDomain.apply(this, arguments);
}

function _disconnectDomain() {
  _disconnectDomain = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(_ref9) {
    var auth, optionals, _endpoints$disconnect, method, url, res;

    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            auth = _ref9.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$disconnect = endpoints.disconnectDomain, method = _endpoints$disconnect.method, url = _endpoints$disconnect.url;
            _context10.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context10.sent;
            return _context10.abrupt("return", res);

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _disconnectDomain.apply(this, arguments);
}

/**
 * Returns a list of sub-accounts
 *
 * @public
 * @param auth {Auth} - User valided authentication
 * @return {Promise<AllAccountsResponse>}
 */
function getSubaccounts(_x22) {
  return _getSubaccounts.apply(this, arguments);
}

function _getSubaccounts() {
  _getSubaccounts = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(_ref10) {
    var auth, optionals, _endpoints$getSubacco, method, url, res;

    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            auth = _ref10.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$getSubacco = endpoints.getSubaccounts, method = _endpoints$getSubacco.method, url = _endpoints$getSubacco.url;
            _context11.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context11.sent;
            return _context11.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              // Stringify the id
              result: res.result.subaccounts.map(function (_ref21) {
                var subaccountId = _ref21.subaccountId,
                    rest = (0, _objectWithoutProperties2["default"])(_ref21, ["subaccountId"]);
                return _objectSpread(_objectSpread({}, rest), {}, {
                  id: String(subaccountId || '')
                });
              })
            }));

          case 7:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _getSubaccounts.apply(this, arguments);
}

/**
 * Returns the invitation link
 *
 * @public
 * @param subaccountId {string} - The subaccount email
 * @param auth {Auth} - User Valided authentication
 * @return {Promise<InvitationLinkResp}
 *
 */
function getInvitationLink(_x23, _x24) {
  return _getInvitationLink.apply(this, arguments);
}

function _getInvitationLink() {
  _getInvitationLink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(subaccountId, _ref11) {
    var auth, optionals, _endpoints$getInvitat, method, url, res;

    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            auth = _ref11.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$getInvitat = endpoints.getInvitationLink, method = _endpoints$getInvitat.method, url = _endpoints$getInvitat.url;
            _context12.next = 5;
            return (0, _requests.request)(url(subaccountId), method, optionals);

          case 5:
            res = _context12.sent;
            return _context12.abrupt("return", res);

          case 7:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _getInvitationLink.apply(this, arguments);
}

/**
 * Create sub-account by valided email address
 *
 * @public
 * @param accountName {string} - name of account to create, e.g. accountName
 * will be 'me' for email address 'me@xbili.com'
 * @param auth {Auth} - User valided authentication
 * @return {Promise<>}
 */
function createSubaccount(_x25, _x26) {
  return _createSubaccount.apply(this, arguments);
}
/**
 * Delete a sub-account by specified id
 *
 * @public
 * @param subaccountId {string} - Uniq account ID
 * @param auth {Auth} - User valided authenticaton
 * @return {Promise<void}
 */


function _createSubaccount() {
  _createSubaccount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(_ref12, _ref13) {
    var accountName, _ref12$thisUser, thisUser, auth, optionals, _endpoints$createSuba, method, url, res;

    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            accountName = _ref12.accountName, _ref12$thisUser = _ref12.thisUser, thisUser = _ref12$thisUser === void 0 ? false : _ref12$thisUser;
            auth = _ref13.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              accountName: accountName,
              thisUser: thisUser
            }))(_utils.defaultOptionals);
            _endpoints$createSuba = endpoints.createSubaccount, method = _endpoints$createSuba.method, url = _endpoints$createSuba.url;
            _context13.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context13.sent;

            if (!(res.status !== 200)) {
              _context13.next = 9;
              break;
            }

            throw new _requests.RequestError(res.message, res.status, res.status);

          case 9:
            return _context13.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: _objectSpread({
                id: String(res.result.subaccountId)
              }, res.result)
            }));

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _createSubaccount.apply(this, arguments);
}

function deleteSubaccount(_x27, _x28) {
  return _deleteSubaccount.apply(this, arguments);
}

function _deleteSubaccount() {
  _deleteSubaccount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(subaccountId, _ref14) {
    var auth, optionals, _endpoints$deleteSuba, method, url, res;

    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            auth = _ref14.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$deleteSuba = endpoints.deleteSubaccount, method = _endpoints$deleteSuba.method, url = _endpoints$deleteSuba.url;
            _context14.next = 5;
            return (0, _requests.request)(url(subaccountId), method, optionals);

          case 5:
            res = _context14.sent;

            if (!(res.status !== 200)) {
              _context14.next = 8;
              break;
            }

            throw new _requests.RequestError(res.message, res.status, res.status);

          case 8:
            return _context14.abrupt("return", res);

          case 9:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _deleteSubaccount.apply(this, arguments);
}

function subaccountSignup(_x29) {
  return _subaccountSignup.apply(this, arguments);
}

function _subaccountSignup() {
  _subaccountSignup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(_ref15) {
    var token, password, captcha, firstName, lastName, birthday, tnc, optIn, recoveryMethod, options, _endpoints$subaccount, method, url, res;

    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            token = _ref15.token, password = _ref15.password, captcha = _ref15.captcha, firstName = _ref15.firstName, lastName = _ref15.lastName, birthday = _ref15.birthday, tnc = _ref15.tnc, optIn = _ref15.optIn, recoveryMethod = _ref15.recoveryMethod;
            options = (0, _functools.compose)( // INFO: Subaccount signup doesn't need the auth user value
            (0, _utils.withAuth)({
              token: token,
              user: ''
            }), (0, _utils.withSignUpHeaders)({
              password: password,
              captcha: captcha,
              recoveryMethod: recoveryMethod
            }), (0, _utils.withSignUpBody)(recoveryMethod, firstName, lastName, birthday, tnc, optIn))(_utils.defaultOptionals);
            _endpoints$subaccount = endpoints.subaccountSignUp, method = _endpoints$subaccount.method, url = _endpoints$subaccount.url;
            _context15.next = 5;
            return (0, _requests.request)(url(), method, options);

          case 5:
            res = _context15.sent;
            return _context15.abrupt("return", res);

          case 7:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _subaccountSignup.apply(this, arguments);
}

/**
 * Returns the link to reset subaccount password
 *
 * @public
 * @param subaccountId {string} - Uniq subaccount ID
 * @param auth {Auth} - User valided authentication
 * @return {Promise<ResetPasswordLinkResp>}
 */
function getResetPasswordLink(_x30, _x31) {
  return _getResetPasswordLink.apply(this, arguments);
}
/**
 * Logs in with an SSO ticket issued by /login API call.
 */


function _getResetPasswordLink() {
  _getResetPasswordLink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(subaccountId, _ref16) {
    var auth, optionals, _endpoints$getResetPa, method, url, res;

    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            auth = _ref16.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$getResetPa = endpoints.getResetPasswordLink, method = _endpoints$getResetPa.method, url = _endpoints$getResetPa.url;
            _context16.next = 5;
            return (0, _requests.request)(url(subaccountId), method, optionals);

          case 5:
            res = _context16.sent;
            return _context16.abrupt("return", res);

          case 7:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _getResetPasswordLink.apply(this, arguments);
}

function ticketLogin(_x32) {
  return _ticketLogin.apply(this, arguments);
}
/**
 * Adds an OnMail alias for the custom domain admin account.
 */


function _ticketLogin() {
  _ticketLogin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(ticket) {
    var _ref17,
        sessionId,
        optionals,
        _endpoints$ticketLogi,
        method,
        url,
        res,
        _args17 = arguments;

    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _ref17 = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : {}, sessionId = _ref17.sessionId;
            optionals = (0, _requests.withHeaders)({
              'x-Domain-Ticket': ticket,
              'x-Super-Session-ID': sessionId
            })(_utils.defaultOptionals);
            _endpoints$ticketLogi = endpoints.ticketLogin, method = _endpoints$ticketLogi.method, url = _endpoints$ticketLogi.url;
            _context17.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context17.sent;
            return _context17.abrupt("return", res);

          case 7:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _ticketLogin.apply(this, arguments);
}

function addOnmailAlias(_x33, _x34) {
  return _addOnmailAlias.apply(this, arguments);
}

function _addOnmailAlias() {
  _addOnmailAlias = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(alias, _ref18) {
    var auth, optionals, _endpoints$addAlias, method, url, res;

    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            auth = _ref18.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              alias: alias
            }))(_utils.defaultOptionals);
            _endpoints$addAlias = endpoints.addAlias, method = _endpoints$addAlias.method, url = _endpoints$addAlias.url;
            _context18.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context18.sent;

            if (!(res.status !== 200)) {
              _context18.next = 8;
              break;
            }

            throw new _requests.RequestError(res.message, res.status, res.status);

          case 8:
            return _context18.abrupt("return", res);

          case 9:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _addOnmailAlias.apply(this, arguments);
}

function getDnsRecords(_x35) {
  return _getDnsRecords.apply(this, arguments);
}

function _getDnsRecords() {
  _getDnsRecords = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(_ref19) {
    var auth, optionals, _endpoints$getDnsReco, method, url, res;

    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            auth = _ref19.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$getDnsReco = endpoints.getDnsRecords, method = _endpoints$getDnsReco.method, url = _endpoints$getDnsReco.url;
            _context19.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context19.sent;
            return _context19.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: res.result.map(function (_ref22) {
                var allowDelete = _ref22.allowDelete,
                    feature = _ref22.feature,
                    record = (0, _objectWithoutProperties2["default"])(_ref22, ["allowDelete", "feature"]);
                return {
                  allowDelete: allowDelete,
                  feature: feature,
                  record: record
                };
              })
            }));

          case 7:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _getDnsRecords.apply(this, arguments);
}

function updateDnsRecords(_x36, _x37) {
  return _updateDnsRecords.apply(this, arguments);
}

function _updateDnsRecords() {
  _updateDnsRecords = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(records, _ref20) {
    var auth, optionals, _endpoints$updateDnsR, method, url, res;

    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            auth = _ref20.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              records: records
            }))(_utils.defaultOptionals);
            _endpoints$updateDnsR = endpoints.updateDnsRecords, method = _endpoints$updateDnsR.method, url = _endpoints$updateDnsR.url;
            _context20.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context20.sent;

            if (!(res.status !== 200)) {
              _context20.next = 8;
              break;
            }

            return _context20.abrupt("return", res);

          case 8:
            return _context20.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: res.result.map(function (_ref23) {
                var allowDelete = _ref23.allowDelete,
                    feature = _ref23.feature,
                    record = (0, _objectWithoutProperties2["default"])(_ref23, ["allowDelete", "feature"]);
                return {
                  allowDelete: allowDelete,
                  feature: feature,
                  record: record
                };
              })
            }));

          case 9:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _updateDnsRecords.apply(this, arguments);
}
//# sourceMappingURL=custom-domains.js.map